export default __webpack_public_path__ + "static/media/Component 73 – 1.1352bad0.svg";